import Link from 'next/link';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { useTranslations } from 'modules/i18n/useTranslations';
import { AppRoutes } from 'modules/shop/routes';
import styles from './styles.module.css';

export const SearchNavigation: FC = () => {
  const t = useTranslations();

  return (
    <Link href={AppRoutes.SEARCH} className={styles.searchNav}>
      <span>{t('search.sidebar-label')}</span>
      <Icon type={IconType.search} />
    </Link>
  );
};
